import { useDealUpdateController } from './useDealUpdateController.ts';
import { DashboardLayout } from '@dealstack/frontend/shared/components/DashboardLayout/DashboardLayout.tsx';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';
import { generatePath, useNavigate } from 'react-router-dom';
import { Loader } from '@mantine/core';
import {
	useTranslationAdminDashboard,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { CreateDealForm } from '@dealstack/frontend/app/pages/Project/CreateDeal/CreateDealForm.tsx';
import { ContainerWithHeader } from '@dealstack/frontend/shared/components/ContainerWithHeader/ContainerWithHeader.tsx';

export const CreateDeal = () => {
	const tAdminDashboard = useTranslationAdminDashboard();
	const tCommonUi = useTranslationCommonUi();
	const navigate = useNavigate();

	const redirectAfterCreate = (dealId?: string) => {
		if (dealId) {
			navigate(generatePath(ROUTES.DEAL, { dealId }));
		} else {
			navigate(ROUTES.DASHBOARD);
		}
	};

	const createDealController = useDealUpdateController({
		callback: redirectAfterCreate,
	});
	const createLoading = createDealController.createDealRequest.isPending;
	const isLoading = createLoading || createDealController.isSettingUp;

	const getEmptyStateText = () => {
		if (createDealController.isSettingUp) {
			return tAdminDashboard('deal.setting_up');
		}
		if (createLoading) {
			return tAdminDashboard('create_deal.empty.loading_text');
		}
		return tAdminDashboard('create_deal.empty.text');
	};

	useBreadcrumbs([
		{
			name: tCommonUi('breadcrumbs.my_deals'),
			url: ROUTES.DASHBOARD,
		},
		{
			name: tCommonUi('breadcrumbs.untitled_deal'),
			url: '',
		},
	]);

	return (
		<DashboardLayout
			sidebar={
				<ContainerWithHeader
					title={tAdminDashboard('deal.sidebar.about_label')}
					icon={<Icon variant="open-book" size="xl" />}
				>
					<CreateDealForm createDealController={createDealController} />
				</ContainerWithHeader>
			}
		>
			<EmptyState icon="es-person-desktop" title={getEmptyStateText()}>
				{isLoading ? <Loader /> : null}
			</EmptyState>
		</DashboardLayout>
	);
};
